function deepCopy(obj) {
    return JSON.parse(JSON.stringify(obj))
}

export default {
    save({ commit, rootGetters, rootState }) {
        const { mrx, session, track } = rootState.v4
        const currentPanel = rootGetters['v4/panel/current'].name
        const encounter = {
            mrx: deepCopy(mrx),
            session: deepCopy(session),
            track: deepCopy(track),
            panel: currentPanel,
        }
        commit('addEncounter', encounter)
    },
    load({ commit, dispatch, state }, encounterId) {
        const existing = state.saved.find(enc => enc.session.uuid === encounterId)
        dispatch('v4/mrx/resume', existing.mrx, { root: true })
        dispatch('v4/session/resume', existing.session, { root: true })
        dispatch('v4/track/resume', existing.track, { root: true })
        commit('removeEncounterById', encounterId)
        return { trackId: existing.track.current.id, panel: existing.panel }
    },
    delete({ commit }, encounterId) {
        commit('removeEncounterById', encounterId)
    },
}
